__turbopack_context__.v({
  "brandName": "Footer-module-scss-module__kQc2fa__brandName",
  "footer": "Footer-module-scss-module__kQc2fa__footer",
  "footerBottom": "Footer-module-scss-module__kQc2fa__footerBottom",
  "heading": "Footer-module-scss-module__kQc2fa__heading",
  "icon": "Footer-module-scss-module__kQc2fa__icon",
  "iconLabel": "Footer-module-scss-module__kQc2fa__iconLabel",
  "iconLink": "Footer-module-scss-module__kQc2fa__iconLink",
  "links": "Footer-module-scss-module__kQc2fa__links",
  "logoIcon": "Footer-module-scss-module__kQc2fa__logoIcon",
  "socialContainer": "Footer-module-scss-module__kQc2fa__socialContainer",
  "socialIcons": "Footer-module-scss-module__kQc2fa__socialIcons",
});
